<script>
export default {
  props: {
    message: { type: String, default: '' },
    duration: { type: Number, default: 2500 },
    action: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<template>
  <div
    class="snackbar-wrapper relative inline-block overflow-hidden rounded-md mb-2 min-w-[15rem] max-w-[25rem] text-left"
  >
    <div
      class="bg-slate-800 dark:bg-slate-700 border border-slate-700 dark:border-slate-600 flex items-center gap-3 min-h-[1.875rem] w-full px-6 py-3 text-left"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ $te(message) ? $t(message) : message }}
      </div>
      <div v-if="action">
        <a
          v-if="action.type == 'link' && action.newTab"
          :href="action.to"
          target="_blank"
          rel="noopener noreferrer"
          class="font-medium cursor-pointer select-none text-woot-500 dark:text-woot-500 hover:text-woot-600 dark:hover:text-woot-600"
        >
          {{ action.message }}
        </a>
        <router-link
          v-else-if="action.type == 'link'"
          :to="action.to"
          class="font-medium cursor-pointer select-none text-woot-500 dark:text-woot-500 hover:text-woot-600 dark:hover:text-woot-600"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
    <div
      class="snackbar-progress"
      :style="{ animationDuration: `${duration}ms` }"
    />
  </div>
</template>

<style lang="scss" scoped>
.snackbar-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0.1875rem;
  width: 100%;
  background: rgba(255, 255, 255, 0.45);
  transform-origin: left center;
  animation-name: shrink-toast-progress;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}

@keyframes shrink-toast-progress {
  from {
    transform: scaleX(1);
  }

  to {
    transform: scaleX(0);
  }
}
</style>
